var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoundEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#BFD8E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H12C10.9 12 10.01 12.9 10.01 14L10 26C10 27.1 10.9 28 12 28H28C29.1 28 30 27.1 30 26V14C30 12.9 29.1 12 28 12ZM27.6 16.25L20.53 20.67C20.21 20.87 19.79 20.87 19.47 20.67L12.4 16.25C12.2997 16.1937 12.2119 16.1177 12.1419 16.0265C12.0719 15.9352 12.0211 15.8308 11.9926 15.7194C11.9641 15.608 11.9585 15.4919 11.9762 15.3783C11.9938 15.2647 12.0343 15.1558 12.0953 15.0583C12.1562 14.9608 12.2363 14.8767 12.3307 14.811C12.4251 14.7453 12.5319 14.6995 12.6445 14.6763C12.7571 14.6531 12.8733 14.653 12.986 14.6759C13.0986 14.6989 13.2055 14.7445 13.3 14.81L20 19L26.7 14.81C26.7945 14.7445 26.9014 14.6989 27.014 14.6759C27.1267 14.653 27.2429 14.6531 27.3555 14.6763C27.4681 14.6995 27.5749 14.7453 27.6693 14.811C27.7637 14.8767 27.8438 14.9608 27.9047 15.0583C27.9657 15.1558 28.0062 15.2647 28.0238 15.3783C28.0415 15.4919 28.0359 15.608 28.0074 15.7194C27.9789 15.8308 27.9281 15.9352 27.8581 16.0265C27.7881 16.1177 27.7003 16.1937 27.6 16.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundEmail);
export default __webpack_public_path__ + "static/media/icon-round-email.0eb74129a650741bb8997a60e55e5674.svg";
export { ForwardRef as ReactComponent };